<template>
	<el-container>
		<div class="top-box">
			<div class="list-head">
				<div class="banner-content">
					<!--					<div class="banner-icon-wrap">-->
					<!--						<i class="el-icon-s-custom"></i>-->
					<!--					</div>-->
					<div class="banner-text" v-if="cinfo.isMain == 1 || (cinfo.isMain === 0 && cinfo.isBuy == 1)">
						<h2>企业中心</h2>
						<p>一站式管理您的企业信息和账户</p>
					</div>

					<div class="banner-text" v-else>
						<h2>账户中心</h2>
						<p>一站式管理您的账户信息</p>
					</div>
				</div>
			</div>
		</div>
	</el-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
		name: 'UserHeader',
		computed: {
			...mapGetters('User', ['cinfo'])
		}
	};
</script>

<style lang="less" scoped>
	.top-box {
		background: linear-gradient(135deg, #155dfc, #4f39f6);
		color: #ffffff;
		padding: 32px 0;
		.list-head {
			width: 78%;
			margin: 0 auto;
		}
		.banner-content {
			display: flex;
			align-items: center;
			gap: 16px;
		}
		.banner-icon-wrap {
			width: 52px;
			height: 52px;
			background: rgba(255, 255, 255, 0.2);
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			i {
				font-size: 22px;
				color: #fff;
			}
		}
		.banner-text {
			h2 {
				margin: 0;
				font-size: 20px;
				color: #fff;
				font-weight: 700;
				line-height: 1.3;
			}
			p {
				margin: 4px 0 0;
				font-size: 14px;
				color: rgba(255, 255, 255, 0.8);
			}
		}
	}
</style>
